import { isContinent } from './fdr-geo-object.utils';

export enum GeoComponents {
  HERO = 'HERO',
  LONG_TEXT = 'LONG_TEXT',
  PRODUCTS = 'PRODUCTS',
  MAP = 'MAP',
  HOTELS = 'HOTELS',
  MEDIA = 'MEDIA',
  DESTINATIONS = 'DESTINATIONS',
  THEMES = 'THEMES',
  ARTICLES = 'ARTICLES',
  SIBLINGS = 'SIBLINGS',
  DYNAMIC_COMPONENTS = 'DYNAMIC_COMPONENTS',
  GEO_STATIC_COMPONENTS = 'GEO_STATIC_COMPONENTS',
  HIGHLIGHTS_SECTION = 'HIGHLIGHTS_SECTION',
  BEST_TRAVEL_PERIOD = 'BEST_TRAVEL_PERIOD',
}

const defaultOrder = [
  GeoComponents.PRODUCTS,
  GeoComponents.MAP,
  GeoComponents.HOTELS,
  GeoComponents.DESTINATIONS,
  GeoComponents.HIGHLIGHTS_SECTION,
  GeoComponents.DYNAMIC_COMPONENTS,
  GeoComponents.MEDIA,
  GeoComponents.LONG_TEXT,
  GeoComponents.SIBLINGS,
  GeoComponents.BEST_TRAVEL_PERIOD,
  GeoComponents.THEMES,
  GeoComponents.ARTICLES,
  GeoComponents.GEO_STATIC_COMPONENTS,
];

const continentOrder = [
  GeoComponents.DESTINATIONS,
  GeoComponents.PRODUCTS,
  GeoComponents.HIGHLIGHTS_SECTION,
  GeoComponents.DYNAMIC_COMPONENTS,
  GeoComponents.MEDIA,
  GeoComponents.LONG_TEXT,
  GeoComponents.BEST_TRAVEL_PERIOD,
  GeoComponents.THEMES,
  GeoComponents.ARTICLES,
  GeoComponents.GEO_STATIC_COMPONENTS,
];

export const getGeoComponentOrder = (id: string): GeoComponents[] =>
  isContinent(id) ? continentOrder : defaultOrder;

export const GEO_THEMES_FONT_COLOR = '#ffffff';
export const GEO_THEME_BG_COLOR = '#7A2739';
